import { React } from 'Imports';
import { createPortal } from 'react-dom';
import Loader from '$Components/Shared/Loader';

const styles = require('./AiOverlayLoadingOverlay.scss') as {
    container: string;
    centered: string;
    loaderWrapper: string;
    message: string;
    subMessage: string;
};

const AiOverlayLoadingOverlay = (): JSX.Element | null => {
    const appRoot = document.getElementById('vp-app-root');
    if (!appRoot) return null;

    return createPortal(
        <div className={styles.container}>
            <div className={styles.centered}>
                <div className={styles.loaderWrapper}>
                    <Loader size={60} color="white" />
                </div>
                <div className={styles.message}>Loading AI overlay</div>
                <div className={styles.subMessage}>This may take a few minutes ...</div>
            </div>
        </div>,
        appRoot,
    );
};

export default AiOverlayLoadingOverlay;
